import React from 'react'
import { FaIndustry, FaBuilding, FaOilCan, FaCogs, FaTruckMonster, FaCar, FaShieldAlt, FaWater, FaBolt } from "react-icons/fa";
import { GiMining, GiPowerGenerator } from "react-icons/gi";
import { FaBoxesStacked } from "react-icons/fa6";

const IndustryWeServe = () => {
    const industries = [
        { name: "Steel", icon: <FaIndustry /> },
        { name: "Construction", icon: <FaBuilding /> },
        { name: "Oil & Gas", icon: <FaOilCan /> },
        { name: "Manufacturing", icon: <FaCogs /> },
        { name: "Mining", icon: <GiMining /> },
        { name: "Transportation", icon: <FaTruckMonster /> },
        { name: "Automobile", icon: <FaCar /> },
        { name: "Defence", icon: <FaShieldAlt /> },
        { name: "Water Utility", icon: <FaWater /> },
        { name: "Power Utility", icon: <FaBolt /> },
        { name: "Power Generation", icon: <GiPowerGenerator /> },
        { name: "Material Handling", icon: <FaBoxesStacked /> },
      ];
  return (
    <>
       {/* Section Heading */}
       <div className="text-center mb-12 ">
        <h3 className="text-4xl mt-12 text-primary font-bold relative inline-block">
          Industries
          <span className="absolute bottom-[-8px] left-0 w-12 h-1 bg-secondary"></span>
          <span className="text-secondary">  We Serve</span>
        </h3>
        <p className="text-gray-600 mt-4">
          Empowering various industries with tailored solutions to meet their needs.
        </p>
      </div>
      
      {/* Industries Grid */}
      <div className="container mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 px-4">
        {industries.map((industry, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center text-center p-6 bg-white shadow-lg rounded-lg hover:shadow-xl transition-shadow"
          >
            <div className="text-3xl text-white mb-4 bg-primary p-4 rounded-full">{industry.icon}</div>
            <h4 className="text-lg font-semibold text-primary">{industry.name}</h4>
          </div>
        ))}
      </div>
    </>
  )
}

export default IndustryWeServe;
